import React from "react"
import {Space, Table} from "antd"
import GroupBuyingDelete from "./GroupBuyingDelete"
import GroupBuyingRelation from "./GroupBuyingRelation"
import GroupBuyingGift from "./GroupBuyingGift"
import GroupBuyingEdit from "./GroupBuyingEdit/GroupBuyingEdit"
import {useGroupBuyingContext} from "../store/useGroupBuyingContext"

const GroupBuyingTable = () => {


    const {grouponListState, page, handlePageChange} = useGroupBuyingContext()

    const columns = [
        {
            title: '团购名称',
            dataIndex: ['groupon', 'name'],
        },
        {
            title: '团购价格（元）',
            dataIndex: ['groupon', 'amount'],
            render: (text, record, _) => {
                return (record.groupon.amount / 100).toFixed(2)
            },
        },
        {
            title: '团购时长（分钟）',
            dataIndex: ['groupon', 'duration'],
            render: (text, record, _) => {
                return (record.groupon.duration / 60).toFixed(0)
            },
        },
        {
            title: '关联美团',
            dataIndex: 'platforms',
            key: 'meiTuanPlatform',
            render: (text, record, _) => {
                const platform = record.platforms.find(item => item.platform.id === 1001)
                if (platform) {
                    return platform.deal.name
                } else {
                    return '否'
                }
            },
        },
        {
            title: '关联抖音',
            dataIndex: 'platforms',
            key: 'douYinPlatforms',
            render: (text, record, _) => {
                const platform = record.platforms.find(item => item.platform.id === 1002)
                if (platform) {
                    return platform.deal.name
                } else {
                    return '否'
                }
            },
        },
        {
            title: '操作',
            dataIndex: 'handling',
            render: (text, record, _) => {
                return (
                    <Space>
                        <GroupBuyingEdit record={record}/>
                        <GroupBuyingDelete grouponId={record.groupon.id}/>
                    </Space>
                )
            },
        },
    ]


    return (
        <div>

            <Table columns={columns}
                   dataSource={grouponListState.data}
                   rowKey={record => record.groupon.id}
                   expandable={{
                       expandedRowRender: (record) => {
                           return (
                               <div>
                                   <Space direction={"vertical"} style={{width: '100%'}}>
                                       <GroupBuyingRelation data={record.platforms}/>
                                       {record.gifts.length > 0 && <GroupBuyingGift gifts={record.gifts}/>}
                                   </Space>
                               </div>
                           )
                       },
                   }}
                   pagination={{
                       pageSize: page.pageSize,
                       current: page.current,
                       onChange: (current, pageSize) => {
                           handlePageChange(current, pageSize)
                       }
                   }}
            />
        </div>
    )
}

export default GroupBuyingTable


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingTable.js